module.exports = __webpack_public_path__ + "df9ceb244b27cc880809d97ce5ddf01d-ui_pipelines_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ugiPipelines/assets/ui_pipelines_2x.jpg
// module id = 830
// module chunks = 0